import React from "react";
import { Mascot } from "./Mascot";
import { RandomButton } from "./RandomButton";
import { Menu } from "lucide-react";

export const NavBar = ({ onJump }) => {
  const links = [
    { k: "timeline", label: "Timeline" },
    { k: "hall-of-shame", label: "Hall of Shame" },
    { k: "gallery", label: "Gallery" },
    { k: "submit", label: "Snitch" },
  ];
  return (
    <nav
      className="sticky top-0 z-40 bg-black/80 backdrop-blur-md brutal-border-y"
      data-testid="navbar"
      style={{ borderTopWidth: 0 }}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 flex items-center justify-between py-3 gap-4">
        <button
          onClick={() => onJump && onJump("top")}
          data-testid="nav-brand"
          className="flex items-center gap-3"
        >
          <Mascot size={44} ring="#FFEA00" />
          <div className="hidden sm:block text-left leading-tight">
            <div className="heading text-lg">DOHERTY</div>
            <div className="font-mono text-[10px] text-[#FFEA00] uppercase">
              Hall of Shame
            </div>
          </div>
        </button>

        <div className="hidden md:flex items-center gap-2">
          {links.map((l) => (
            <button
              key={l.k}
              onClick={() => onJump && onJump(l.k)}
              data-testid={`nav-${l.k}`}
              className="brutal-press font-mono text-[12px] uppercase font-bold px-3 py-2 brutal-border bg-black text-white"
              style={{ boxShadow: "3px 3px 0 0 #FFEA00", borderWidth: 3 }}
            >
              {l.label}
            </button>
          ))}
          <RandomButton compact />
        </div>

        <div className="md:hidden">
          <button
            data-testid="nav-mobile-menu"
            onClick={() => onJump && onJump("timeline")}
            className="brutal-border p-2 bg-[#FFEA00] text-black"
            style={{ borderWidth: 3 }}
          >
            <Menu size={18} strokeWidth={3} />
          </button>
        </div>
      </div>
    </nav>
  );
};
